import { styled } from '@acko-tech/building-blocks.ui.common';

export const Container = styled.div`
    min-height: 100vh;
    padding-bottom: 32px;
`;

export const SectionsCard = styled.div`
    width: 95%;
    margin: 16px auto 0;
    padding: 10px 24px;
    border-radius: 12px;
    background: #ffffff;

    @media screen and (max-width: 769px) {
        width: 100%;
        margin: 0;
        padding: 10px 14px 20px;
        border-radius: 0;
    }
`;

export const TitleRow = styled.div`
    display: flex;
    gap: 10px;
`;

export const BackButton = styled.button`
    border: 0;
    background: transparent;
    padding: 0;
    color: #5d4aa8;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
`;

export const PageTitle = styled.h1`
    font-weight: 600;
    font-size: 20px;
    margin: 0;
`;

export const SectionDivider = styled.div`
    width: 100%;
    height: 1px;
    background: #ece9f4;
`;
